module.exports = __webpack_public_path__ + "static/media/linkedinLogo.138e62be.png";